import * as React from "react";
import type { SVGProps } from "react";
const SvgDismissExtraSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.616 15.586A1 1 0 0 0 9 15.66a1 1 0 0 0 .71-.29l2.12-2.12 2.12 2.12a1 1 0 0 0 .71.29 1 1 0 0 0 .71-1.71l-2.12-2.12 2.12-2.12a1.004 1.004 0 1 0-1.42-1.42l-2.12 2.12-2.12-2.12a1.004 1.004 0 0 0-1.42 1.42l2.12 2.12-2.12 2.12a1 1 0 0 0 .326 1.636"
    />
  </svg>
);
export default SvgDismissExtraSmall;
